import { render, staticRenderFns } from "./ContractPayment.vue?vue&type=template&id=0b450011&scoped=true&"
import script from "./ContractPayment.vue?vue&type=script&lang=js&"
export * from "./ContractPayment.vue?vue&type=script&lang=js&"
import style0 from "./ContractPayment.vue?vue&type=style&index=0&id=0b450011&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b450011",
  null
  
)

export default component.exports